import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IHrDepartmentState } from './hr-department.types';
import { IHrDepartmentData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IHrDepartmentState = {
  version: 1,
  hrDepartments: [] as IHrDepartmentData[],
  lastPromise: null
};

const namespaced = true;

export const hrDepartment: Module<IHrDepartmentState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
